import { syncRender } from 'globalCommon/services/syncRender';
import commonPageService from 'pcCommon/services/commonPageService';
import './style.css';

function init() {
    commonPageService({ renderAfter: syncRender });
}

init();
